
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.297 0H.703A.703.703 0 000 .703V14.86c0 .389.315.704.703.704H2.86v2.109c0 .388.315.703.704.703H9.89v4.922c0 .388.314.703.703.703h2.812a.703.703 0 00.703-.703v-4.922h6.329a.703.703 0 00.703-.703v-2.11h2.156A.703.703 0 0024 14.86V.703A.703.703 0 0023.297 0zM4.266 16.969v-1.407H9.89v1.407H4.266zm8.437 5.625h-1.406v-7.032h1.406v7.032zm7.031-5.625H14.11v-1.407h5.625v1.407zm2.86-2.813H1.406V1.406h2.86v1.407h-.704a.703.703 0 000 1.406h2.813a.703.703 0 000-1.407h-.703V1.407h5.625v1.407h-.703a.703.703 0 100 1.406h2.812a.703.703 0 100-1.407h-.703V1.407h5.625v1.407h-.703a.703.703 0 000 1.406h2.813a.703.703 0 000-1.407h-.704V1.407h2.86v12.75z","fill":"#00003C"}}),_c('rect',{staticClass:"active-highlight",attrs:{"x":"2.844","y":"2.8","width":"4.267","height":"1.422","rx":".711","fill":"#E2E4EC"}}),_c('rect',{staticClass:"active-highlight",attrs:{"x":"9.867","y":"2.8","width":"4.267","height":"1.422","rx":".711","fill":"#E2E4EC"}}),_c('rect',{staticClass:"active-highlight",attrs:{"x":"16.889","y":"2.8","width":"4.267","height":"1.422","rx":".711","fill":"#E2E4EC"}})])
          )
        }
      }
    